var render, staticRenderFns
import script from "./vBase.vue?vue&type=script&lang=js&"
export * from "./vBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f1fc6",
  null
  
)

export default component.exports